export const esData = `
  <div class="paragraph">
    <div class="title">INFORMACIÓN AL USUARIO</div>
    <div class="text-box">
      <div class="text">
      DANGHUAN EUROPE S.L., como Responsable del Tratamiento, le informa que, según lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril, (RGPD) y en la L.O. 3/2018, de 5 de diciembre, de protección de datos y garantía de los derechos digitales (LOPDGDD), trataremos su datos tal y como reflejamos en la presente Política de Privacidad.
      </div>
      <div class="text">
      En esta Política de Privacidad describimos cómo recogemos sus datos personales y por qué los recogemos, qué hacemos con ellos, con quién los compartimos, cómo los protegemos y sus opciones en cuanto al tratamiento de sus datos personales.
      </div>
      <div class="text">
      Esta Política se aplica al tratamiento de sus datos personales recogidos por la empresa para la prestación de sus servicios. Si acepta las medidas de esta Política, acepta que tratemos sus datos personales como se define en esta Política.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">CONTACTO</div>
    <div class="text-box">
      <div class="text">
       Denominación social: DANGHUAN EUROPE S.L.
      </div>
      <div class="text">
      Nombre comercial: Danghuan
      </div>
      <div class="text">
      CIF: B19961911
      </div>
      <div class="text">
      Domicilio: Calle Tomás Bretón, 46, 28045, Madrid, Spain
      </div>
      <div class="text">
      e-mail: <span class="email">legal@danghuan.eu</span>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">PRINCIPIOS CLAVE</div>
    <div class="text-box">
      <div class="text">
      Siempre hemos estado comprometidos con prestar nuestros servicios con el más alto grado de calidad, lo que incluye tratar sus datos con seguridad y transparencia. Nuestros principios son:
      </div>
      <div class="text">• Legalidad: Solo recopilaremos sus Datos personales para fines específicos, explícitos y legítimos.</div>
      <div class="text">• Minimización de datos: Limitamos la recogida de datos de carácter personal a lo que es estrictamente relevante y necesario para los fines para los que se han recopilado.</div>
      <div class="text">• Limitación de la Finalidad: Solo recogeremos sus datos personales para los fines declarados y solo según sus deseos.</div>
      <div class="text">• Precisión: Mantendremos sus datos personales exactos y actualizados.</div>
      <div class="text">• Seguridad de los Datos: Aplicamos las medidas técnicas y organizativas adecuadas y proporcionales a los riesgos para garantizar que sus datos no sufran daños, tales como divulgación o acceso no autorizado, la destrucción accidental o ilícita o su pérdida accidental o alteración y cualquier otra forma de tratamiento ilícito. </div>
      <div class="text">Acceso y Rectificación: Disponemos de medios para que acceda o rectifique sus datos cuando lo considere oportuno.</div>
      <div class="text">• Conservación: Conservamos sus datos personales de manera legal y apropiada y solo mientras es necesario para los fines para los que se han recopilado.</div>
      <div class="text">• Las transferencias internacionales: cuando se dé el caso de que sus datos vayan a ser transferidos fuera de la UE/EEE se protegerán adecuadamente.</div>
      <div class="text">• Terceros: El acceso y transferencia de datos personales a terceros se llevan a cabo de acuerdo con las leyes y reglamentos aplicables y con las garantías contractuales adecuadas.</div>
      <div class="text">• Marketing Directo y cookies: Cumplimos con la legislación aplicable en materia de publicidad y cookies.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">RECOGIDA Y TRATAMIENTO DE SUS DATOS PERSONALES</div>
    <div class="text-box">
      <div class="text">
      Las tipos de datos que se pueden solicitar y tratar son:
      </div>
      <div class="text">• Datos de carácter identificativo.</div>
      <div class="text">También recogemos de forma automática datos sobre su visita a nuestro sitio web  según se describe en la política de cookies.</div>
      <div class="text">Siempre que solicitemos sus Datos personales, le informaremos con claridad de qué datos personales recogemos y con qué fin. En general, recogemos y tratamos sus datos personales con el propósito de:</div>
      <div class="text">• Proporcionar información, servicios, productos, información relevante y novedades en el sector.</div>
      <div class="text">• Envío de comunicaciones.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">LEGITIMIDAD</div>
    <div class="text-box">
      <div class="text">De acuerdo con la normativa de protección de datos aplicable, sus datos personales podrán tratarse siempre que:</div>
      <div class="text">• Nos ha dado su consentimiento a los efectos del tratamiento. Por supuesto podrá retirar su consentimiento en cualquier momento.</div>
      <div class="text">• Por requerimiento legal.</div>
      <div class="text">• Por exisitr un interés legítimo que no se vea menoscabado por sus derechos de privacidad, como por ejemplo el envío de información comercial bien por suscripción a nuestra newsletter o por su condición de cliente.</div>
      <div class="text">•Por se necesaria para la prestación de alguno de nuestros servicios mediante relación contractual entre usted y nosotros.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">COMUNICACIÓN DE DATOS PERSONALES</div>
    <div class="text-box">
      <div class="text">Los datos pueden ser comunicados a empresas relacionadas con DANGHUAN EUROPE S.L. para la prestación de los diversos servicios en calidad de Encargados del Tratamiento. La empresa no realizará ninguna cesión, salvo por obligación legal.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">SUS DERECHOS</div>
    <div class="text-box">
      <div class="text">
      En relación con la recogida y tratamiento de sus datos personales, puede ponerse en contacto con nosotros en cualquier momento para:
      </div>
      <div class="text">• Acceder a sus datos personales y a cualquier otra información indicada en el Artículo 15.1 del RGPD.</div>
      <div class="text">• Rectificar sus datos personales que sean inexactos o estén incompletos de acuerdo con el Artículo 16 del RGPD.</div>
      <div class="text">• Suprimir sus datos personales de acuerdo con el Artículo 17 del RGPD.</div>
      <div class="text">• Limitar el tratamiento de sus datos personales de acuerdo con el Artículo 18 del RGPD.</div>
      <div class="text">• Solicitar la portabilidad de sus datos de acuerdo con el Artículo 20 del RGPD.</div>
      <div class="text">• Oponerse al tratamiento de sus datos personales de acuerdo con el artículo 21 del RGPD.</div>
      <div class="text">Si ha otorgado su consentimiento para alguna finalidad concreta, tiene derecho a retirar el consentimiento otorgado en cualquier momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada RRHH.</div>
      <div class="text">Puede ejercer estos derechos enviando comunicación, motivada y acreditada, a <span class="email">legal@danghuan.eu.</span></div>
      <div class="text">También tiene derecho a presentar una reclamación ante la Autoridad de control competente (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa vigente.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">INFORMACIÓN LEGAL</div>
    <div class="text-box">
      <div class="text">
      Los requisitos de esta Política complementan, y no reemplazan, cualquier otro requisito existente bajo la ley de protección de datos aplicable, que será la que prevalezca en cualquier caso.
      </div>
      <div class="text">
      Esta Política está sujeta a revisiones periódicas y la empresa puede modificarla en cualquier momento. Cuando esto ocurra, le avisaremos de cualquier cambio y le pediremos que vuelva a leer la versión más reciente de nuestra Política y que confirme su aceptación.</div>
    </div>
  </div>
`;
